<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('editionIntervention.infoGenerale.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-narrow mgb-20px">
            <figure class="media-left">
              <app-logo ></app-logo>
            </figure>
          </div>
          <div class="column">
            <div class="columns is-multiline">
              <div class="column is-3">
                <b-field :label="$t('editionIntervention.infoGenerale.dateIntervention')"
                         :class="{'obligatoire': !isNonDefini }">
                  <b-datepicker show-week-number
                                v-model="demandeIntervention.datePlanification"
                                icon="calendar-today"
                                nearby-selectable-month-days editable>
                  </b-datepicker>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('editionIntervention.infoGenerale.typeIntervention')">
                  <b-select v-model="demandeIntervention.type"
                            @input="demandeIntervention.typeOtId = null"
                            expanded>
                    <option
                      v-for="item in tabTypeModuleIntervention"
                      :key="item.key"
                      :value="item.key">
                      {{ $t(item.libelle) }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-3">
                <user-autocomplete
                  v-model="demandeIntervention.demandeurId"
                  :label="$t('editionIntervention.infoGenerale.demandeur')"
                  :obligatoire="isIntervention"
                />
              </div>
              <div class="column is-3">
                <b-field :label="$t('editionIntervention.infoGenerale.source')">
                  <b-select v-model="demandeIntervention.source" expanded>
                    <option v-for="item in sourceIntervention"
                            :key="item.key"
                            :value="item.key">
                      {{ $t(item.libelle) }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-3" v-if="isIntervention">
                <b-field class="obligatoire"
                         :label="$t('editionIntervention.infoGenerale.typeOt')">
                  <b-select v-model="demandeIntervention.typeOtId" expanded>
                    <option v-for="item in typesOT"
                            :key="item.id"
                            :value="item.id">
                      {{ item.libelle }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('editionIntervention.infoGenerale.patrimoine')"
                         custom-class="is-marginless">
                  <a v-if="!getLibellePatrimoine"
                     @click="$emit('goToUpdatePatrimoine')"
                     class="lien">
                    {{ $t('editionIntervention.infoGenerale.patrimoineInfo.add') }}
                  </a>
                  <div v-else class="columns">
                    <router-link-blank :to="getRouterLinkPatrimoine"
                                       class="column is-10"
                                       :message="getLibellePatrimoine"
                                       typeIcon="is-primary" sizeIcon="is-small">
                    </router-link-blank>
                    <b-tooltip
                      :label="$t('editionIntervention.infoGenerale.canNotChangePatrionine')"
                      :active="canNotChangePatrionine"
                      multilined
                      position="is-left">
                      <a class="column is-2 has-text-right"
                        @click="deletePatrimoine()"
                        :class="{'disabled': canNotChangePatrionine}">
                        <b-icon
                          :type="{'is-danger': !canNotChangePatrionine }"
                          icon="delete-forever"
                          :class="{'text-access-no-permission': canNotChangePatrionine}">
                        </b-icon>
                      </a>
                    </b-tooltip>
                  </div>
                </b-field>
              </div>
              <div class="column is-3" v-if="agencesSelectionnees.length > 1">
                <selection-agence v-model="demandeIntervention.agenceId"
                                  :obligatoire="true"
                                  setFirstAgenceFind>
                </selection-agence>
              </div>
              <div class="column is-3">
                <b-field :label="$t('editionIntervention.infoGenerale.etat')">
                  {{ getLibelleEtat }}
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('editionIntervention.infoGenerale.dateLimite')">
                  <b-datepicker show-week-number
                    v-model="demandeIntervention.dateLimite"
                    icon="calendar-today"
                    nearby-selectable-month-days editable>
                  </b-datepicker>
                </b-field>
              </div>
              <div class="column is-3" v-if="isIntervention">
                <b-field :label="$t('editionIntervention.infoGenerale.OT')"
                         custom-class="is-marginless">
                  <router-link-blank :to="{ name: 'c.logistique.ordre_travail-tech',
        params: { id: demandeIntervention.otTechnique.id } }"
                                     v-if="demandeIntervention.otTechnique"
                                     :message="demandeIntervention.otTechnique.code"
                                     typeIcon="is-primary" sizeIcon="is-small">
                  </router-link-blank>
                </b-field>
              </div>
              <div class="column is-6" v-if="isIntervention">
                <b-field :label="$t('editionIntervention.infoGenerale.tags')">
                  <query-tags-tag-input
                    :tooltipLabel="$t('editionCampagne.tagInfo')"
                    v-model="demandeIntervention.tags"
                    field="tag"
                    :moduleTag="constantes.moduleDemandeIntervention">
                  </query-tags-tag-input>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  ETAT_DEMANDE_INTERVENTION, INTERVENTION_TYPE_INTERVENTION,
  INTERVENTION_TYPE_NON_DEFINI,
  SOURCE_INTERVENTION, TYPE_INTERVENTION,
} from '@/configuration/logistique/intervention/interventionConf';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import selectionAgence from '@/components/general/selectionAgence';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import Logo from '@/components/general/Logo';
import userAutocomplete from '@/components/commun/user/userAutocomplete';
import cloneDeep from 'lodash/cloneDeep';
import {
  FABRICATION_DISPOSITIF, DISPOSITIF_FABRIQUE,
} from '@/configuration/logistique/typeOt/typeOtConfig';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import { DEMANDE_INTERVENTION as moduleDemandeIntervention } from '@/configuration/parametrage/tagConf';

const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'infoGeneraleIntervention',
  props: {
    demandeIntervention: {
      required: true,
      type: Object,
    },
    isUpdate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    selectionAgence,
    routerLinkBlank,
    appLogo: Logo,
    userAutocomplete,
    queryTagsTagInput,
  },
  data() {
    return {
      isFetching: false,
      typeIntervention: TYPE_INTERVENTION,
      sourceIntervention: SOURCE_INTERVENTION,
      constantes: {
        moduleDemandeIntervention,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
    isIntervention() {
      return this.demandeIntervention.type === INTERVENTION_TYPE_INTERVENTION;
    },
    isNonDefini() {
      return this.demandeIntervention.type === INTERVENTION_TYPE_NON_DEFINI;
    },
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    moduleLogistiqueTechniqueActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
    tabTypeModuleIntervention() {
      const allIntervention = cloneDeep(this.typeIntervention);
      if (!this.moduleLogistiqueTechniqueActive) {
        const getItemToSplice = allIntervention.find((el) => el.key === 'Intervention');
        const index = allIntervention.indexOf(getItemToSplice);
        allIntervention.splice(index, 1);
      }
      return allIntervention;
    },
    getLibellePatrimoine() {
      if (this.demandeIntervention.faceId) {
        return this.$i18n.t('editionIntervention.infoGenerale.patrimoineInfo.face', {
          ref: this.demandeIntervention.infoPatrimoine.face.code,
        });
      }
      if (this.demandeIntervention.materielId) {
        return this.$i18n.t('editionIntervention.infoGenerale.patrimoineInfo.materiel', {
          ref: this.demandeIntervention.infoPatrimoine.materiel.code,
        });
      }
      if (this.demandeIntervention.dispositifId) {
        return this.$i18n.t('editionIntervention.infoGenerale.patrimoineInfo.dispositif', {
          ref: this.demandeIntervention.infoPatrimoine.dispositif.code,
        });
      }
      if (this.demandeIntervention.emplacementId) {
        return this.$i18n.t('editionIntervention.infoGenerale.patrimoineInfo.emplacement', {
          ref: this.demandeIntervention.infoPatrimoine.emplacement.code,
        });
      }
      return null;
    },
    getRouterLinkPatrimoine() {
      if (this.demandeIntervention.faceId) {
        return {
          name: 'c.gabed.emplacement-face',
          params: {
            id: this.demandeIntervention.infoPatrimoine.emplacement.id,
            idFace: this.demandeIntervention.infoPatrimoine.face.id,
          },
        };
      }
      if (this.demandeIntervention.materielId) {
        return {
          name: 'c.gabed.emplacement-detailMateriel',
          params: {
            id: this.demandeIntervention.infoPatrimoine.emplacement.id,
            idMateriel: this.demandeIntervention.infoPatrimoine.materiel.id,
          },
        };
      }
      if (this.demandeIntervention.dispositifId) {
        return {
          name: 'c.gabed.emplacement-detailDispositif',
          params: {
            id: this.demandeIntervention.infoPatrimoine.emplacement.id,
            idDispositif: this.demandeIntervention.infoPatrimoine.dispositif.id,
          },
        };
      }
      if (this.demandeIntervention.emplacementId) {
        return {
          name: 'c.gabed.emplacement-detailEmplacement',
          params: {
            id: this.demandeIntervention.infoPatrimoine.emplacement.id,
          },
        };
      }
      return null;
    },
    getLibelleEtat() {
      const etatFind = ETAT_DEMANDE_INTERVENTION.find((etat) => {
        return etat.key === this.demandeIntervention.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    canNotChangePatrionine() {
      if (!this.demandeIntervention.typeOtId) return false;
      const typeOt = this.typesOT.find(t => {
        return t.id === this.demandeIntervention.typeOtId;
      });
      return this.isUpdate && [FABRICATION_DISPOSITIF, DISPOSITIF_FABRIQUE]
        .includes(typeOt.actionInterventionOt);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    deletePatrimoine() {
      this.demandeIntervention.faceId = null;
      this.demandeIntervention.materielId = null;
      this.demandeIntervention.dispositifId = null;
      this.demandeIntervention.emplacementId = null;
      this.demandeIntervention.infoPatrimoine = {
        faceId: null,
        materielId: null,
        dispositifId: null,
        emplacementId: null,
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.typeOt,
      ]);
      if (!this.$route.params.id) {
        this.demandeIntervention.demandeurId = this.user.id;
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
